/*
<summary>
   This higher-order component is all about wrapping a component with Loan Out Tool popup visibility state and its toggle handler.
   Developer: Aashish Singh, Created Date: 20-Aug-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { useState } from 'react';

const LoanOutToolPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showLoanOutToolPopup, setShowLoanOutToolPopup] = useState<boolean>(false);

    const loanOutToggleHandler = () => {
      setShowLoanOutToolPopup(!showLoanOutToolPopup);
    };

    return (
      <Component
        showLoanOutToolPopup={showLoanOutToolPopup}
        loanOutToggleHandler={loanOutToggleHandler}
        {...props}
      />
    );
  };

export default LoanOutToolPopupHOC;
